import { render, staticRenderFns } from "./naviateToWxapp.vue?vue&type=template&id=39cd712e&scoped=true"
import script from "./naviateToWxapp.vue?vue&type=script&lang=js"
export * from "./naviateToWxapp.vue?vue&type=script&lang=js"
import style0 from "./naviateToWxapp.vue?vue&type=style&index=0&id=39cd712e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cd712e",
  null
  
)

export default component.exports